


















import { Component, Vue } from 'vue-property-decorator';
import AppLayoutDefault from '@/layouts/AppLayoutDefault.vue';
import AppLayoutLogin from '@/layouts/AppLayoutLogin.vue';
import moment from 'moment';
import { Month, Months } from '@/typings/month';

@Component({
	components: {
		AppLayoutDefault,
		AppLayoutLogin,
	},
})
export default class App extends Vue {
	// sets background images for uat and local environments

	public layout() {
		return this.$route.meta.layout || 'AppLayoutDefault';
	}

	public getLocalOpacity(): number {
		return window.location.host.indexOf('local') > -1 ? 1 : 0;
	}

	public getUatOpacity(): number {
		return window.location.host.indexOf('uat') > -1 ? 1 : 0;
	}

	public getMonth(): Month | null {
		const month = Object.keys(Months).find((key: string) => {
			return Months[key].month == moment().month();
		});
		if (month) return Months[month];
		return null;
	}

	public getMonthlyBackground(): string | null | undefined {
		return this.getMonth()?.name;
	}

	public getMonthlyOpacity(): number {
		return this.getMonth() ? 0.2 : 0;
	}
}
